import { createEndAIExperienceCommand } from '../actions';
import { getPluginState } from '../decoration-plugin-factory';
import { hasGeneratedContentDecorations } from './hasGeneratedContentDecorations';
export var onClearGeneratedContentDecorator = function onClearGeneratedContentDecorator(view, event) {
  var pluginState = getPluginState(view.state);
  if (hasGeneratedContentDecorations(pluginState)) {
    var endAIExperienceCommand = createEndAIExperienceCommand();
    endAIExperienceCommand(view.state, view.dispatch);
    return true;
  }
  return false;
};